
import { defineComponent, ref } from "vue";

import { BaseButton } from "@tager/admin-ui";

import { FormValues } from "@/views/ProductForm/ProductForm.helpers";

import PriceTable from "./PriceTable.vue";

type Props = Readonly<{
  values: FormValues;
}>;

export default defineComponent({
  name: "ExtendedPrice",
  components: { PriceTable, BaseButton },
  props: {
    values: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const priceMultipleValues = ref(props.values.priceMultipleValues);

    function addElement() {
      priceMultipleValues.value.push({
        id: undefined,
        name: "",
        description: "",
        price: "0",
        discountType: null,
        onDiscount: false,
        discountValue: "0",
      });
    }

    return {
      addElement,
      priceMultipleValues,
    };
  },
});
